import React, {FC, ReactNode} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Placement} from "react-bootstrap/types";

interface TooltipItemProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
    id?: string,
    title?: ReactNode,
    position: Placement;
    backgroundColor?: string
}

const TooltipItem: FC<TooltipItemProps> = ({id, title, position, children, backgroundColor = '#000'}) => {
    const entering = (e: any) => {
        e?.children[0]?.style?.setProperty('--bs-tooltip-bg', backgroundColor);
        e.children[1].style.backgroundColor = backgroundColor;
    }

    return (
        <OverlayTrigger
            key={'top'}
            placement={position}
            delay={{show: 150, hide: 400}}
            overlay={<Tooltip id={'tooltip-' + id}><>{title}</></Tooltip>}
            onEntering={entering}
        >
            <span data-testid="TooltipItem">{children}</span>
        </OverlayTrigger>
    );
};

export default TooltipItem;
